import { Grid, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';

import { getTranslucentSurfaceStyles } from 'components/theme/theme';

const DashboardFooter = () => {
  const theme = useTheme();
  return (
    <Grid
      container
      alignItems="center"
      sx={{
        ...getTranslucentSurfaceStyles(theme),
        px: 3,
        py: 1,
      }}
    >
      <Grid item>
        <Typography variant="caption" color="text.disabled">
          Nucleai Platform is for research use only and has not been validated for use in any diagnostic procedures.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default DashboardFooter;
